module.exports = __webpack_public_path__ + "static/media/MUSICAL.17b378ba.png";